import React from 'react';
import { Helmet } from 'react-helmet';
import '../pages/GlobalHomePage.css';

export default function GlobalHomePage({ onCardNavigate }) {
  return (
    <>
      <Helmet>
        <title>Home | Insight Data LLC</title>
      </Helmet>
      <main className="gl-modern-home">
        <section className="gl-modern-hero">
          <h1 className="gl-modern-title">Insight Data LLC</h1>
          <p className="gl-modern-subtitle">Data-driven projects, analytics, and insights for a smarter world.</p>
        </section>
        <section className="gl-modern-cards">
          <div className="gl-modern-card" onClick={() => onCardNavigate('cv')} tabIndex={0} role="button" style={{cursor:'pointer'}}>
            <h2>About</h2>
            <p>Learn more about Jakob Gutzmann and his work in data science, analytics, and engineering.</p>
          </div>
          <div className="gl-modern-card" onClick={() => onCardNavigate('projects')} tabIndex={0} role="button" style={{cursor:'pointer'}}>
            <h2>Projects</h2>
            <p>Explore a portfolio of data-driven projects, from economic analysis to geospatial visualization and AI chatbots.</p>
          </div>
          <div className="gl-modern-card" onClick={() => onCardNavigate('contact')} tabIndex={0} role="button" style={{cursor:'pointer'}}>
            <h2>Contact</h2>
            <p>Get in touch for collaborations, consulting, or to learn more about Insight Data LLC.</p>
          </div>
        </section>
      </main>
    </>
  );
}
